import { Link, Outlet, Navigate, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { useEffect, useState } from "react";
import { Loader } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const EXPIRED_ACCESS_ALLOWED_PATHS = ["/access-expired", "/dashboard"];

const PrivateRoutesWrapper = () => {
  const { user, accessStatus, validateCookie } = useUser();
  const [loading, setLoading] = useState<boolean>(true);
  const [authorised, setAuthorised] = useState<boolean>(false);
  const location = useLocation();
  const isExpiredAccessAllowedRoute = EXPIRED_ACCESS_ALLOWED_PATHS.includes(location.pathname);

  useEffect(() => {
    const callValidateCookieFunction = async () => {
      try {
        const result = await validateCookie();
        setAuthorised(result.valid);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    // only check cookie if no user obj exists in state already.
    if (user) {
      setLoading(false);
      setAuthorised(true);
    } else {
      callValidateCookieFunction();
    }
  }, [user, validateCookie]);

  if (loading) {
    return (
      <div
        style={{
          display: "grid",
          height: "100%",
        }}
      >
        <Loader
          size="md"
          content="Loading..."
          style={{
            margin: "auto",
          }}
        />
      </div>
    );
  }

  if (!authorised) {
    return <Navigate to="/login" />;
  }

  if (user?.type === "student" && accessStatus === "expired" && !isExpiredAccessAllowedRoute) {
    return <Navigate to="/access-expired" replace />;
  }

  return <Outlet />;
};

export default PrivateRoutesWrapper;
